module.exports = __webpack_public_path__ + "img/pt.07f887f2.svg";